<div [ngClass]="['md:h-full', (forceFullHeight$ | async) ? 'h-full' : '']">
  <mat-drawer-container class="h-full">
    <mat-drawer-content class="py-3">
      <router-outlet></router-outlet>
    </mat-drawer-content>
    <mat-drawer [opened]="multiImageDownloadActive$ | async" class="bg-white border-l border-gray-200" mode="side"
                position="end">
      <cat-multi-image-download></cat-multi-image-download>
    </mat-drawer>
  </mat-drawer-container>
</div>
